
import React from 'react';
import styled from 'styled-components';
import { 
	func,
	node,
	oneOfType,
	string
} from 'prop-types';
import '../../../i18n';
import { withNamespaces } from 'react-i18next';
import { RemoveIcon } from '../../atoms/Icons';
import IconButton from '../../atoms/IconButton';
import {DividerColor,LightPrimaryColor,OnSurface} from '../../Colors';
import {InfoTooltip} from '../Tooltip';

const style = {
	Help : styled.div`
		& > dl {
			position : relative;
			& > dt {
				margin-bottom : 0.5rem;
				padding-right : 20px;
			}
			border : solid 1px ${DividerColor};
			background-color : ${LightPrimaryColor};
			padding : 1rem;
			color : ${OnSurface};
			& > #closeButton {
				position: absolute;
				right : 0;
				top : 5px;
			}
		}
	`,
};

const HelpBox = ({className, term, description,onClose, t}) => {
	return (
		<style.Help className={className}>
			<dl>
				<dt id='term'>
					{term}
				</dt>
				<dd id='description'>
					{description}
				</dd>
				{onClose&&(
					<InfoTooltip text={t('common.HideHelp')}>
						<IconButton id='closeButton' onClick={onClose}><RemoveIcon/></IconButton>
					</InfoTooltip>
				)}
			</dl>
		</style.Help>
	);
};

HelpBox.propTypes = {
	className : string,
	onClose : func,
	term : oneOfType([
		string,
		node,
	]),
	description : oneOfType([
		string,
		node,
	]),
};

export default withNamespaces()(HelpBox);



